import { StateModel } from '../../shared/models/default-state.model';

import {
  GET_APPLICATIONS_REQUEST,
  GET_APPLICATIONS_SUCCESS,
  GET_APPLICATIONS_ERROR,
} from '../actions/applications.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: [],
};

export const applicationsReducer = (state: StateModel = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case GET_APPLICATIONS_REQUEST:
      return {
        ...state,
        loaded: false,
        loading: true,
      };

    case GET_APPLICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
      };

    case GET_APPLICATIONS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default applicationsReducer;
